// extracted by mini-css-extract-plugin
export default {"question":"Answer_question__+4aub","sourcesContainer":"Answer_sourcesContainer__yQ1gx"};